@if (chartsCountSg() === 1) {
  <!-- In case that there is only one chart, we want to display it on whole
  widget, and to avoid calculations for grid layout, only one chart is displayed
  without any classes-->
  <atn-ds-chart [chart]="chartsSg()[0]" />
} @else {
  <div
    #sunburstChartsContainer
    class="sunburst-chart-grid-container"
    [style.--sunburst-chart--min-width]="minWidth"
    [style.--sunburst-chart--min-height]="minHeight"
    [style.--sunburst-charts--max-columns]="columnsCountSg()"
    [style.--sunburst-charts--rows]="rowsCountSg()"
    [style.--sunburst-chart--container-height]="containerHeightSg()"
  >
    @for (chart of chartsSg(); track $index) {
      <atn-ds-chart [chart]="chart" />
    }
  </div>
}
